import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { FaBars } from "react-icons/fa";
import logo from "../../assets/logo spartnerg.png";
import "./NavBarResponsive.css";

const NavBarResponsive = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="navBarResponsive">
      <div className="navBarResponsive__header">
        <div className="navBarResponsive__logo">
          <div className="navBarResponsive__logo cogno-logo-navbar">
            <Link to="/home">
              <img src={logo} alt="Cognoseguridad" />
            </Link>
          </div>
        </div>
        <button className="menu-toggle" onClick={toggleMenu}>
          <FaBars />
        </button>
      </div>

      {isMenuOpen && (
        <div className="navBarResponsive__links">
          <Link to="/home#homeAboutUs" onClick={toggleMenu}>Sobre nosotros</Link>
          <Link to="/home#homeMAndV" onClick={toggleMenu}>Mision y vision</Link>
          <Link to="/home#homeAllies" onClick={toggleMenu}>Asociados</Link>
          <Link to="/home#contact" onClick={toggleMenu}>Contactanos</Link>
        </div>
      )}
    </div>
  );
};

export { NavBarResponsive };
